import React, { Component } from 'react'
import { Alert, Input, Modal, Spin, Table, Tag, Typography, message } from 'antd'
import {
    addVibeProjectUploadAuthorizers,
    getVibeProjectUploadAuthorizers,
} from '../../request'
import { filterUploadAuthorizers, getNewUploadAuthorizerIds, isEnabledFlag } from './vibeUploadAuthorizer'

const { Text } = Typography

class VibeUploadAuthorizerDialog extends Component {
    state = {
        loading: false,
        loadError: false,
        saving: false,
        project: null,
        users: [],
        selectedUserIds: [],
        keyword: '',
    }

    componentDidMount() {
        if (this.props.visible && this.props.project) {
            this.loadUsers(this.props.project)
        }
    }

    componentDidUpdate(prevProps) {
        const projectChanged = String(prevProps.project?.id || '') !== String(this.props.project?.id || '')
        if (this.props.visible && this.props.project && (!prevProps.visible || projectChanged)) {
            this.loadUsers(this.props.project)
        } else if (!this.props.visible && prevProps.visible) {
            this.resetState()
        }
    }

    resetState = () => {
        this.setState({
            loading: false,
            loadError: false,
            saving: false,
            project: null,
            users: [],
            selectedUserIds: [],
            keyword: '',
        })
    }

    loadUsers = project => {
        this.setState({
            loading: true,
            loadError: false,
            project,
            users: [],
            selectedUserIds: [],
            keyword: '',
        })
        getVibeProjectUploadAuthorizers({ projectId: project.id })
            .then(res => {
                const users = Array.isArray(res?.users) ? res.users : []
                this.setState({
                    project: { ...project, ...(res || {}) },
                    users,
                    selectedUserIds: users
                        .filter(item => isEnabledFlag(item.uploadAuthorized))
                        .map(item => String(item.userId)),
                })
            })
            .catch(() => this.setState({ loadError: true }))
            .finally(() => this.setState({ loading: false }))
    }

    close = () => {
        if (this.state.saving) return
        if (this.props.onClose) this.props.onClose()
    }

    save = () => {
        const { project, users, selectedUserIds } = this.state
        const userIds = getNewUploadAuthorizerIds(users, selectedUserIds)
        if (!userIds.length) {
            message.info('请选择至少一名尚未授权的上传人员')
            return
        }
        this.setState({ saving: true })
        addVibeProjectUploadAuthorizers({ projectId: project.id, userIds })
            .then(res => {
                message.success(`已新增 ${Number(res?.addedCount) || userIds.length} 名上传人员`)
                if (this.props.onSaved) this.props.onSaved(res)
                if (this.props.onClose) this.props.onClose()
            })
            .catch(() => {})
            .finally(() => this.setState({ saving: false }))
    }

    render() {
        const {
            loading,
            loadError,
            saving,
            project,
            users,
            selectedUserIds,
            keyword,
        } = this.state
        const filteredUsers = filterUploadAuthorizers(users, keyword)
        const newUserIds = getNewUploadAuthorizerIds(users, selectedUserIds)
        return (
            <Modal
                title={`授权上传数据：${project?.projectName || this.props.project?.projectName || '-'}`}
                visible={this.props.visible}
                width={760}
                confirmLoading={saving}
                okButtonProps={{ disabled: loading || loadError || !newUserIds.length }}
                okText={`新增授权（${newUserIds.length}）`}
                cancelText="取消"
                onOk={this.save}
                onCancel={this.close}
                closable={!saving}
                maskClosable={!saving}
                destroyOnClose
            >
                <Alert
                    showIcon
                    type="info"
                    message="被授权人员可用自己的 Codex 上传此 AIC 项目数据"
                    description="系统会把勾选人员的正式姓名追加到 data_owner。为兼容历史自由文本，当前只新增、不自动移除已有上传人员。"
                    style={{ marginBottom: 12 }}
                />
                {project?.dataOwner ? (
                    <div style={{ marginBottom: 12 }}>
                        <Text type="secondary">当前 data_owner：</Text>
                        <Text>{project.dataOwner}</Text>
                    </div>
                ) : null}
                <Input.Search
                    allowClear
                    value={keyword}
                    placeholder="搜索姓名或登录账号"
                    onChange={event => this.setState({ keyword: event.target.value })}
                    style={{ width: 320, marginBottom: 12 }}
                />
                <Spin spinning={loading}>
                    {loadError ? (
                        <Alert type="error" showIcon message="人员加载失败，请关闭弹窗后重试。" />
                    ) : (
                        <Table
                            rowKey={record => String(record.userId)}
                            size="small"
                            pagination={{ pageSize: 10, showSizeChanger: false }}
                            dataSource={filteredUsers}
                            locale={{ emptyText: '暂无可授权人员' }}
                            rowSelection={{
                                preserveSelectedRowKeys: true,
                                selectedRowKeys: selectedUserIds,
                                onChange: keys => this.setState({ selectedUserIds: keys.map(String) }),
                                getCheckboxProps: record => ({
                                    disabled: isEnabledFlag(record.isOwner)
                                        || isEnabledFlag(record.uploadAuthorized),
                                }),
                            }}
                            columns={[
                                {
                                    title: '人员',
                                    key: 'user',
                                    render: (_, record) => (
                                        <div>
                                            <div>
                                                {record.userNick || record.userName || record.userId || '-'}
                                                {isEnabledFlag(record.isOwner)
                                                    ? <Tag color="blue" style={{ marginLeft: 8 }}>项目 Owner</Tag>
                                                    : null}
                                                {isEnabledFlag(record.uploadAuthorized)
                                                    ? <Tag color="green" style={{ marginLeft: 8 }}>已可上传</Tag>
                                                    : null}
                                            </div>
                                            <Text type="secondary" style={{ fontSize: 12 }}>
                                                {record.userName || record.userId || '-'}
                                            </Text>
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    )}
                </Spin>
            </Modal>
        )
    }
}

export default VibeUploadAuthorizerDialog
